import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { CrudBaseService } from '../crud.service';
import { Deposit, IManualDeposit } from '../models';

@Injectable()
export class DepositService extends CrudBaseService<Deposit> {
    constructor(protected httpClient: HttpClient) {
        super('/deposit', httpClient);
    }

    static updateDepositStatus(deposits: Deposit[]): Deposit[] {
        const depositList = deposits.sort(
            (a, b) => new Date(a.created_date!).getTime() - new Date(b.created_date!).getTime()
        );

        depositList.forEach((deposit: Deposit) => {
            if (deposit.refunded_amount! >= deposit.deposit_amount!) {
                deposit.status = 'REFUNDED';
            }
        });
        
        return depositList;
    }
}

@Injectable()
export class CreateBankWireTransferDepositService extends DepositService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient);
    }

    override create(model: IManualDeposit): Observable<any> {
        return this.httpClient.post(`${this.apiBasePath}/pay_admin/bankwiretransfer`, { data: model }).pipe(
            map((res: any) => {
                return { data: res.data?.reference };
            })
        );
    }
}

@Injectable()
export class SyncDepositService extends DepositService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient);
    }

    override create(model: Deposit): Observable<any> {
        return this.httpClient
            .post(`${this.apiBasePath}/deposit/${model.id}/sync`, {})
            .pipe(map((res: { data: any }) => res.data));
    }
}

@Injectable()
export class RepairDepositService extends DepositService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient);
    }

    override update(id: string, model: Deposit): Observable<any> {
        return this.httpClient.patch(`${this.basePath}/${id}/repair`, {
            data: model
        });
    }
}
